import type { Assembler } from '@@partner:types:app'
import type { CRUD_Variables, GQL_Edge } from '@@partner:types:graphql'

import { gql, useLazyQuery, useQuery } from '@apollo/client'

import {
  SHORTCUT_EMPLOYEE_FIELDS,
  SHORTCUT_PAGE_INFO_FIELDS
} from '@@partner:graphql/shortcuts'

export interface AllAssemblersQueryResult {
  assemblers: GQL_Edge<Assembler[]>
}

export interface AllAssemblersQueryVariables extends CRUD_Variables {}

const GQL_QUERY_ALL_ASSEMBLERS = gql`
  query (
    $filter: NestedFilterInput
    $pager: CommonPagerInput
    $sort: CommonSortInput
  ) {
    assemblers: allAssemblers(
      filter: $filter
      sort: $sort
      pager: $pager
    ) {
      edges {
        ${SHORTCUT_EMPLOYEE_FIELDS}
        shop {
          id
          name
        }
      }
      pageInfo {
        ${SHORTCUT_PAGE_INFO_FIELDS}
      }
    }
  }
`

export const useFetchAllAssemblers = (variables: AllAssemblersQueryVariables, skip?: boolean) =>
  useQuery<AllAssemblersQueryResult, AllAssemblersQueryVariables>(
    GQL_QUERY_ALL_ASSEMBLERS,
    { variables, fetchPolicy: 'cache-and-network', skip }
  )


export const useLazyFetchAssemblers = (variables?: AllAssemblersQueryVariables) => 
  useLazyQuery<AllAssemblersQueryResult, AllAssemblersQueryVariables>(GQL_QUERY_ALL_ASSEMBLERS, {
    variables
  })